import axios from '@vtblife/axios';
import { cmsDataUrlByEnvironmentMap } from '@vtblife/block-kit-utils';
export const getQuizProps = async ({ id, environment = 'production', }) => {
    if (!id) {
        throw new Error('id обязателен');
    }
    try {
        const { data } = await axios.get(`${cmsDataUrlByEnvironmentMap[environment]}/json/quiz/${id}.json`);
        return data.props;
    }
    catch (error) {
        console.error(`Ошибка при загрузке квиза с id: ${id}`, error);
        throw error;
    }
};
//# sourceMappingURL=get-quiz-props.js.map